import React from "react";
import Helmet from "react-helmet";
// import { Link } from '@reach/router';

import Navigation from "../../components/WaveNavigation/";
import Island from "../../components/Island/";
import Beach from "../../components/Cards/beach";
import PageHeader from "../../components/PageHeader";

import watertaxiimage from "../../assets/img/instagram/watertaxi@oceanbeach_fi.jpg";
import saltaireimage from "./images/saltaire3@abonventre.jpg";
import fairharborimage from "./images/fair-harbor@abonventre.jpg";

import seaviewimage from "../../assets/img/beaches/seaview.jpg";
import pointowoodsimage from "../../assets/img/beaches/point-o-woods.jpg";
import lighthouseimage from "./images/lighthouse@fiferries.jpg";
import oceanbeachimage from "./images/ocean-beach@fiferries.jpg";
import sunkenforestimage from "./images/sunkenforest2@fiwatertaxi.jpg";
import sailorshavenimage from "./images/sunkenforest@fiferries.jpg";
import kismetimage from "./images/kismet@fiferries.jpg";
import pinesimage from "./images/fiPines.jpg";

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Communities"
      meta={[
        {
          name: "description",
          content:
            "Even though it’s only a short distance from Manhattan, Fire Island is a world away from the hustle and bustle of city life. Boasting 32 miles of pristine beaches, Fire Island offers visitors an escape from mainland pressures with beautiful Atlantic Ocean beaches, calming views of the Great South Bay, and access to peaceful wilderness.",
        },
        {
          name: "keywords",
          content: "Fire Island, New York, Long Island, Ferries, Water Taxi",
        },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader>
        <h2>Communities</h2>
        <h1>Fire Island</h1>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="heading">
        <h1>About Fire Island</h1>
      </div>
      <p>
        Even though it’s only a short distance from Manhattan, Fire Island is a
        world away from the hustle and bustle of city life. Boasting 32 miles of
        pristine beaches, Fire Island offers visitors an escape from mainland
        pressures with beautiful Atlantic Ocean beaches, calming views of the
        Great South Bay, and access to peaceful wilderness.
      </p>
      <p>
        Fire Island has remained an unspoiled oasis for city folk and Long
        Islanders alike thanks to the efforts of its various communities, the
        Fire Island National Seashore, and the National Park Services.
      </p>
      <Island />
      <p>
        Besides enjoying the beach, Fire Island visitors can experience fine
        dining in several of the communities, a unique night life, a walk
        through a majestic holly forest, and even climb to the top of the Fire
        Island Lighthouse.
      </p>
      <p>
        There are seventeen communities on Fire Island. Each has its own unique
        personality which adds to the wonder of the island. Several of the
        communities are strictly residential while others have restaurants,
        shops, marinas, and playgrounds catering to both homeowners and visitors
        alike. Many of the communities are accessible by ferry or private boats,
        but all enjoy a car free lifestyle, using bikes and wagons as the
        primary means of transportation.
      </p>
      <h2>Learn more about each community below.</h2>
      <br />
      <div className="row">
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={lighthouseimage}
            link="/communities/fi-lighthouse"
            beach="Lighthouse"
            description="An iconic landmark of Fire Island. Climb to the top for a breathtaking panoramic view."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={kismetimage}
            link="/communities/kismet"
            beach="Kismet"
            description="A family freindly community with beaches, shops, and restaurants."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={saltaireimage}
            link="/communities/saltaire"
            beach="Saltaire"
            description="A primarily residential community with great views."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={fairharborimage}
            link="/communities/fair-harbor"
            beach="Fair Harbor"
            description="Community with quaint walkways and fine dining."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={watertaxiimage}
            link="/communities/dunewood"
            beach="Dunewood"
            description="A small community in a charming hamlet of Fire Island"
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={watertaxiimage}
            link="/communities/atlantique"
            beach="Atlantique"
            description="Limited access provides serenity unlike anywhere else."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={oceanbeachimage}
            link="/communities/ocean-beach"
            beach="Ocean Beach"
            description="Something for everyone, beachs, restaurants, hotels, and shops."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={seaviewimage}
            link="/communities/seaview"
            beach="Seaview"
            description="A family friendly community offering wholesome fun for everyone."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={watertaxiimage}
            link="/communities/ocean-bay-park"
            beach="Ocean Bay Park"
            description="A lively community with restaurants and hotels."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={pointowoodsimage}
            link="/communities/point-o-woods"
            beach="Point O' Woods"
            description="An exclusive community with it's own ferry service for residents."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={sailorshavenimage}
            link="/communities/sailors-haven-sunken-forest"
            beach="Sailor's Haven"
            description="Wonderfully remote, offering a marina, snack bar, picnic area, and visitor center."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={sunkenforestimage}
            link="/communities/sailors-haven-sunken-forest"
            beach="Sunken Forest"
            description="Don't miss this unique opportunity, visit a unique maritime holly forest."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={watertaxiimage}
            link="/communities/cherry-grove"
            beach="Cherry Grove"
            description="Lively atmosphere with something for everyone."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={pinesimage}
            link="/communities/fi-pines"
            beach="F.I. Pines"
            description="A beach escape from city life offering many shops and restaurants."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={watertaxiimage}
            link="/communities/water-island"
            beach="Water Island"
            description="Quietest community with limited access."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={watertaxiimage}
            link="/communities/davis-park"
            beach="Davis Park"
            description="Come visit the famous Casino Bar & Cafe with live music and dancing."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={watertaxiimage}
            link="/communities/watch-hill"
            beach="Watch Hill"
            description="Largest F.I. Nationa Seashore complex offers the only camping site on F.I."
          />
        </div>
      </div>

      <br />
      <br />
    </div>
  </div>
);
